import cookies from 'js-cookie';

export function getDeviceId() {
  const deviceId = cookies.get('cookie_id');

  return deviceId ?? '';
}
